import { loadRemote } from '../moduleFederation';

const storeMap = Object.create(null);
let storeMapGenerator;

export async function getStore(storeName) {
	//ensure the stores are loaded
	await getAllStores();
	return storeMapGenerator[storeName] ? storeMapGenerator[storeName]() : undefined;
}

export async function getAllStores() {
	if (!storeMapGenerator) {
		try {
			const {
				GlobalStore,
				PlanStore,
				AvailabilityStore,
				ProductAvailabilityStore,
				CartStore,
				UserStore,
				BookingsStore,
			} = await loadRemote('Stores');

			storeMapGenerator = {
				planStore() {
					if (!storeMap.planStore) {
						storeMap.planStore = new PlanStore();
					}
					return storeMap.planStore;
				},
				userStore() {
					if (!storeMap.userStore) {
						storeMap.userStore = new UserStore();
					}
					return storeMap.userStore;
				},

				availabilityStore() {
					if (!storeMap.availabilityStore) {
						storeMap.availabilityStore = new AvailabilityStore({
							planStore: storeMapGenerator.planStore(),
							userStore: storeMapGenerator.userStore(),
						});
					}
					return storeMap.availabilityStore;
				},
				cartStore() {
					if (!storeMap.cartStore) {
						storeMap.cartStore = new CartStore({
							userStore: storeMapGenerator.userStore(),
						});
					}
					return storeMap.cartStore;
				},
				bookingsStore() {
					if (!storeMap.bookingsStore) {
						storeMap.bookingsStore = new BookingsStore({
							userStore: storeMapGenerator.userStore(),
						});
					}
					return storeMap.bookingsStore;
				},
				productAvailabilityStore() {
					if (!storeMap.productAvailabilityStore) {
						storeMap.productAvailabilityStore = new ProductAvailabilityStore({
							cartStore: storeMapGenerator.cartStore(),
							bookingsStore: storeMapGenerator.bookingsStore(),
							userStore: storeMapGenerator.userStore(),
						});
					}
					return storeMap.productAvailabilityStore;
				},
				globalStore() {
					if (!storeMap.globalStore) {
						storeMap.globalStore = new GlobalStore(window?.FS?.propertyInfo?.owsCode);
					}
					return storeMap.globalStore;
				},
			};
		} catch (error) {
			console.error('Unable to load stores');
		}
	}
	return storeMapGenerator;
}
